import CenterTemplate from 'components/center/CenterTemplate';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ActionCtor } from 'store/modules/main';

const CenterPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(ActionCtor.getRoomInfos(undefined));
    dispatch(ActionCtor.selectRoom(undefined));
    dispatch(ActionCtor.getVessel(undefined));
    dispatch(ActionCtor.getRescues(undefined));
  }, [dispatch]);

  return <CenterTemplate />;
};

export default CenterPage;
